import type { RelatedInventoryRiskItem } from '../Api/Projects/projectsApi';

// One home for what the Risk column makes of a row, so its mark, sort, filter options and filtering cannot disagree.

// statusFormatter's word for a live service, and saved filters store it: renaming it empties them.
export const ACTIVE_RISK_LABEL = 'Active';

type RiskColumnRow = Pick<RelatedInventoryRiskItem, 'riskTier' | 'riskLabel' | 'riskState'>;

export const isLiveService = (row: RiskColumnRow): boolean => !!row.riskTier && row.riskState === 'resolved';

// A live service still arrives with the green tier's label, which would file it beside the green dots.
export const riskColumnLabel = (row: RiskColumnRow): string | null | undefined =>
  isLiveService(row) ? ACTIVE_RISK_LABEL : row.riskLabel;
